// extracted by mini-css-extract-plugin
export default {"PageLayout":"settings-view-module__PageLayout--ECs_w","Pane":"settings-view-module__Pane--PwYFT","Content":"settings-view-module__Content--OQ_4a"};